export const MARKETPLACE_HOSTNAME = 'marketplace.obraa.com.br';
export const MARKETPLACE_WWW_HOSTNAME = 'www.marketplace.obraa.com.br';
export const MARKETPLACE_ORIGIN = `https://${MARKETPLACE_HOSTNAME}`;

export function isMarketplaceHostname(hostname = window.location.hostname) {
  return hostname === MARKETPLACE_HOSTNAME || hostname === MARKETPLACE_WWW_HOSTNAME;
}

export function isObraaPrimaryHostname(hostname = window.location.hostname) {
  return hostname === 'obraa.com.br' || hostname === 'www.obraa.com.br';
}

export function buildMarketplacePublicUrl(path = '') {
  const normalizedPath = String(path || '').startsWith('/') ? path : `/${path}`;
  return `${MARKETPLACE_ORIGIN}${normalizedPath}`;
}
